<template>
  <HomeContainer
    :title="'Online İç Denetim Nedir? Soru Setleri Nasıl Hazırlanmıştır? Sıkça Sorulan Sorular'"
  >
    <b-tabs type="is-toggle is-medium" expanded v-model="tabNo">
      <b-tab-item label="Online İç Denetim Nedir?">
        <div class="content">
          <p>“Online İç Denetim” bir Neta Denetim ürünüdür.</p>
          <p>
            onlineicdenetim.com sayfası şirketinizin kritik süreçlerine ait iç kontrol yeterliliğini
            hızlıca, kendi kendinize ve tek bir platformda değerlendirmeniz için tasarlanmıştır. İç
            Denetim uygulamalarını kurumunuz bünyesinde İç Kontrol ve/veya İç Denetim birimlerinin
            var olup olmamasından bağımsız olarak kullanabilirsiniz.
          </p>

          <p>
            Kurumunuz bünyesinde kontrol seviyesini test etmek istediğiniz süreci seçin, iç denetim
            soru setini cevaplayın, anında size özel Neta Skorunuzu öğrenin ve değerlendirme
            raporunuzu alın.
          </p>

          <p>
            Alacağınız skor ve rapor Neta Denetim’in bir değerlendirmesi olup, dünyada genel kabul
            görmüş standartlar baz alınarak hazırlanmaktadır.
          </p>

          <p>
            Dilerseniz zaman içinde yapacağınız süreç iyileştirme çalışmalarını takiben İç Denetim
            uygulamalarını 3 aylık dönemlerde yeniden cevaplayıp, gelişiminizi takip edebilir, tek
            raporda mevcut ve geçmiş dönem seviyenizi ve cevaplarınızı kıyaslayabilirsiniz.
          </p>

          <p>
            Site güvenliği ile ilgili merak ettiklerinizi “Önemli Bilgilendirmeler” başlığı altında
            bulabilirsiniz.
          </p>
        </div>
      </b-tab-item>
      <b-tab-item label="Soru Setleri Nasıl Hazırlandı?">
        <div class="content">
          <p>İç denetim süreç soru setleri;</p>
          <ul>
            <li>
              Dünyada genel kabul görmüş
              <router-link :to="{ name: 'definitions' }">COSO iç kontrol standartları</router-link>
            </li>
            <li>
              Bilgi Teknolojileri alanında
              <router-link :to="{ name: 'definitions', params: { tab: 1 } }"
                >CobIT kontrol ve denetim standartları</router-link
              >
            </li>
            <li>
              Birçok uluslararası firma tarafından uygulanan Amerika Birleşik Devletleri’nde
              yürürlüğe girmiş Sarbanes Oxley 404 İç Kontrollere İlişkin Düzenlemeler kanunu,
              gözetilerek hazırlanmıştır.
            </li>
          </ul>
          <p>
            Kısaca SOX olarak anılan bu kanun ve uygulamalar bazı ülkeler tarafından kendi
            standartlarına göre de uyarlanmış ve gereklilik olarak kabul edilmiştir.
          </p>
          <p>
            Tüm bu hazırlıklar CIA (Certified Internal Auditor - Sertifikalı İç Denetçi) ve CISA
            (Certified Information Systems Auditor - Sertifikalı Bilgi Sistemleri Denetçisi)
            sertifikalı, farklı iş kolları ve sektörlerde kurumsal tecrübeye sahip iç denetçiler
            tarafından yürütülmüştür.
          </p>
          <p>
            Burada kurgulanan puanlama ve üretilen raporlar; yukarıda detaylandırılmış iç kontrol
            standartları ve hazırlayan “denetçi tecrübelerinin” bir bütünüdür.
          </p>
        </div>
      </b-tab-item>
      <b-tab-item label="Sıkça Sorulan Sorular">
        <div class="content">
          <b-collapse
            class="card"
            v-for="(collapse, index) of collapses"
            :key="index"
            :open="isOpen == index"
            @open="isOpen = index"
            :animation="null"
          >
            <div slot="trigger" slot-scope="props" class="card-header" role="button">
              <p class="card-header-title">{{ collapse.title }}</p>
              <a class="card-header-icon">
                <b-icon :icon="props.open ? 'sort-down' : 'sort-up'"></b-icon>
              </a>
            </div>
            <div class="card-content">
              <div class="content" v-html="collapse.text"></div>
            </div>
          </b-collapse>
        </div>
      </b-tab-item>
    </b-tabs>
  </HomeContainer>
</template>

<script>
export default {
  data () {
    return {
      tabNo: this.$route.query.no,
      isOpen: 0,
      collapses: [
        {
          title: 'Online İç Denetim sitesi kimler için, ne amaçla hazırlandı?',
          text: `<p>Şirketinizde i&ccedil; denetim yaptırmak istediğinizde karşınızdaki muhtemel &ccedil;&ouml;z&uuml;mler:</p>
<ul>
<li>* bağımsız bir denetim firmasından danışmanlık almak, veya</li>
<li>* tecr&uuml;beli i&ccedil; denet&ccedil;iler istihdam etmektir.</li>
</ul>
<p>Oysa şimdi yeni bir se&ccedil;eneğiniz var. Onlineicdenetim.com ile şirketinizin i&ccedil; denetimini online, hızlı bir şekilde ve kendi kendinize yapabilirsiniz.&nbsp;</p>
<p>&Uuml;stelik &ccedil;ok daha az b&uuml;t&ccedil;e ayırarak.</p>
<p>Operasyonlarınız planlarınızın &ouml;tesinde bir hızla b&uuml;y&uuml;d&uuml; ise, organizasyon yapınız genişledi, yapılan iş, &uuml;retilen &uuml;r&uuml;n sayısı sizin &ldquo;tek başınıza&rdquo; kontrol edebileceğiniz sınırlara geldiyse Online İ&ccedil; Denetim &uuml;r&uuml;n&uuml;n&uuml; kullanabilirsiniz.</p>
<p>&nbsp;&Uuml;lke genelinde veya sınır &ouml;tesi geniş b&ouml;lge ağında iş yapıyor ve operasyonlarınızda kişisel g&uuml;vene dayalı kontroller &ouml;n planda ise Online İ&ccedil; Denetim sizler i&ccedil;in bir başlangı&ccedil; olacaktır!</p>
<p>&nbsp;Kurumunuz i&ccedil;in yabancı ortaklık arayışındaysanız, İ&ccedil; Kontrol ve İ&ccedil; Denetimin size ve kurumunuza kredibilite katacağını biliyorsanız Online İ&ccedil; Denetim ile ilk adımı atabilirsiniz!</p>
`
        },
        {
          title: 'Online İç Denetim sitesi bana ne verecek?',
          text: `<p>Kendi kendinizi denetlemeniz sonucunda operasyonlarınız &uuml;zerinde eksik i&ccedil; kontrol mekanizmaları ve bunların sonucu operasyonlarınızın ne kadar kırılgan olduğu bilgisine sahip olacaksınız.</p>
<p>Bu bilgilere alacağınız; Skor Panosu, İ&ccedil; Kontrol Değerlendirme Raporu, S&uuml;re&ccedil; Soru-Cevap d&ouml;k&uuml;m&uuml; ile ulaşacaksınız.&nbsp;</p>
<p>Bu raporları anında ekranda inceleyeceğiniz gibi, Online İ&ccedil; Denetim sitesine &uuml;ye olurken bildirdiğiniz elektronik posta adresinize PDF &ccedil;ıktıları iletilecektir.</p>
`
        },
        {
          title: 'Siteye üye olurken ve kullanırken özel bilgi sorulmakta mı?',
          text: `<p>Online İ&ccedil; Denetim sitesine &uuml;ye olurken m&uuml;mk&uuml;n olan en az bilgi isteme yoluna gittik.</p>
<p>&Uuml;ye olurken ve kendi kendinizi denetlerken sizlerin paylaşmaktan imtina edebileceği hi&ccedil;bir ticari bilgi istenmeyecektir.</p>
<p>Online İ&ccedil; Denetim sitesi &uuml;r&uuml;nlerini sizlere ulaştırabilmek i&ccedil;in elektronik posta adresiniz ve size iletilecek raporlarda gerektiğinde kullanmak i&ccedil;in iştigal konunuz dışında bir bilgi istenmiyor.</p>
<p>Online İ&ccedil; Denetim sitesini t&uuml;m fonksiyonları ile kullanmak istemeniz durumunda sizlere ilgili faturanızı iletebilmek i&ccedil;in bilgileriniz ayrıca talep edilecektir.</p>
`
        },
        {
          title: 'Ücretsiz kullanım hakkı içeriğinde neler var?',
          text: `<p>Sizlerin Online İ&ccedil; Denetim &uuml;r&uuml;n&uuml;n&uuml; g&ouml;rebilmesi, test edebilmesi i&ccedil;in herkesin kullanımına a&ccedil;ık b&ouml;l&uuml;m&uuml; &uuml;cretsizdir.</p>
<p>&nbsp;Bu alanda sizler i&ccedil;in kullanıma a&ccedil;ık &ldquo;Kendi Kendine İ&ccedil; Denetim&rdquo; uygulamalarını 1 kere kullanabilir, Denetim Skor Tablosunu alabilir, Denetim Raporunuza erişebilirsiniz.</p>
`
        },
        {
          title: 'Online İç Denetim sitesi neden ücretli?',
          text: `<p>Kullanıcılara &uuml;cretsiz sunulan &uuml;r&uuml;nlerde aslında kullanıcıların &uuml;r&uuml;n olduğuna inanıyoruz!</p>
<p>&Uuml;cretli &uuml;yelik &ccedil;eşidine g&ouml;re İ&ccedil; Denetim uygulamalarını kullanabilir, değerlendirme sonucu alacağınız skor panosu ile genel kabul g&ouml;rm&uuml;ş standartlar &ouml;l&ccedil;&uuml;s&uuml; ile i&ccedil; kontrol seviyenizi &ouml;l&ccedil;ebilir, zaman i&ccedil;inde gelişiminizi grafikler ile takip edebilir, ilgili değerlendirme raporlarınıza ulaşabilirsiniz.</p>
<p>Dilerseniz daha geniş site kullanım hakları ile ek İ&ccedil; Denetim uygulama setlerini birlikte hazırlayabilir, online ortamda kullanımınıza sunabiliriz. Hatta bu yetkiyi sizlere verebilir, sizlerin dilediğiniz İ&ccedil; Denetim uygulamasını oluşturmanıza dışardan destek verebiliriz.&nbsp;&nbsp;</p>
<p>B&ouml;ylece ihtiya&ccedil;larınıza y&ouml;nelik s&uuml;re&ccedil;leri, sizlerin belirleyeceği firma ve kurumlara online ortamda uygulama, değerlendirme ve kıyaslama imkanı elde edebilirsiniz.</p>
`
        },
        {
          title: 'Standart Paket ile Kurumsal Paket Arasında Ne Fark Var?',
          text: `<p>Standart Paket üyelik çerçevesinde 12 adet denetim setini yıllık üyelik süresi boyunca 2 defa uygulama imkanı vermektedir.</p>
          <p>Kurumsal Üyelik içinde farklı uygulama seçenekleri bulunmaktadır.</p>
          <p>Bu seçenekler arasında kısaca; denetim setlerinin sınırsız sayıda kullanımı, kendi denetim setlerini oluşturabilme, sisteme alt işletme tanımlayabilme ve farklı denetim setleri ile denetleyebilmek gibi alternatifleri sayabiliriz.</p>`
        },
        {
          title: 'Online İç Denetim Üyeliği Neden Yıllık Yapılmakta?',
          text: `<p>Tecrübelerimiz göstermektedir ki tespit edilen kontrol eksikliklerini bertaraf edecek aksiyonları uygulamaya almak, uygulamaların şirket kültürü olarak yerleşmesini sağlamak senelik zaman dilimlerini bulmaktadır. </p>
<p>Yıllık üyelik ile; kendi kendine iç denetim tekrarı, dönemsel olarak denetim sonuçlarını kıyaslama ve tüm bunları grafiksel görebilme imkanı verilmektedir.</p>
<p>Böylece aksiyon takip takvimi çıkartabilir, aksiyonları takip edebilir ve gelişiminizi dönem içinde İnceleme imkanına sahip olabilirsiniz.</p>
`
        },
        {
          title: 'Online İç Denetim uygulamalarını ne zaman tekrarlamalıyım?',
          text: `<p>Kurumunuz;</p>
<ul>
<li>Operasyonlarında bir değişiklik meydana geldiği zaman,</li>
</ul>
<ul>
<li>Kullandığınız yazılımlarda yapılacak g&uuml;ncellemeler veya başka bir yazılma ge&ccedil;ilmesi,&nbsp;</li>
<li>Operasyonlarınız ile ilgili yasal d&uuml;zenleme ve uygulama değişikliği olduğunda</li>
</ul>
<ul>
<li>İş hacminde yaşanan ani &ccedil;ıkış ve iniş d&ouml;nemlerinde,</li>
<li>Organizasyon yapısında yaşanan değişiklik d&ouml;nemlerinde,</li>
<li>Organizasyon şemasında, y&ouml;netim kadrosunda, yeni personel alımlarında vs.</li>
</ul>
<p>Online İ&ccedil; Denetim uygulamalarını size bağlı y&ouml;netici ve &ccedil;alışanlar ile cevaplamanızı, risk analizi yapmanızı &ouml;neririz.</p>
`
        },
        {
          title: 'Online İç Denetim süreçlerini nasıl uygulamalıyım?',
          text: `<p>İ&ccedil; Denetim uygulamalarının &ldquo;hazırlık&rdquo; b&ouml;l&uuml;m&uuml;nde sizlere yol g&ouml;sterecek a&ccedil;ıklamalar bulacaksınız.</p>
<p>Genel yaklaşım olarak asla tek kişi kendi başına t&uuml;m sorulara cevap vermemelidir!</p>
<p>Her bir s&uuml;re&ccedil; denetimi; ilgili s&uuml;re&ccedil; y&ouml;neticisi (şef, m&uuml;d&uuml;r vb), s&uuml;recin fiili uygulayıcısı (uzman, memur vb), s&uuml;recin i&ccedil; m&uuml;şterileri (diğer b&ouml;l&uuml;m y&ouml;netici ve uzmanları) ile toplantıyı y&ouml;netecek &uuml;st d&uuml;zey bir y&ouml;neticinin mevcudiyeti ile yapılmalıdır.&nbsp;</p>
<p>Sorular ve a&ccedil;ıklamaları kuşkuya yer bırakmayacak şekilde katılımcılar arasında konuşulmalı, değerlendirilmeli ve cevap verilmelidir.&nbsp;</p>
<p>Toplantı y&ouml;neticisi soruları ek ve &ccedil;apraz sorular ile derinleştirip, mevcut durumdan emin olarak cevap şıkkını işaretlemelidir.</p>
`
        },
        {
          title:
            'Online İç Denetim uygulamaları sırasında yardım ihtiyacımız olursa destek alabilir miyiz?',
          text: `<p>İ&ccedil; Denetim uygulamaları esnasında sorulara ait detay a&ccedil;ıklama notları sizlere uygulama anında yardımcı olacaktır.</p>
<p>Ayrıca sayfanın sağ alt k&ouml;şesinde mevcut &ldquo;Online İ&ccedil; Denetim Destek&rdquo; fonksiyonunu kullanabilirsiniz. En kısa s&uuml;rede sizlere d&ouml;n&uuml;lecektir.&nbsp;</p>
<p>Bu esnada dilerseniz İ&ccedil; Denetim uygulamasına &ldquo;sakla ve &ccedil;ık&rdquo; se&ccedil;eneği ile ara verebilir, daha sonra kaldığınız yerden devam edebilirsiniz.&nbsp;</p>
`
        },
        {
          title: 'Kendi ihtiyaçlarıma yönelik, Online İç Denetim uygulamaları oluşturabilir miyim?',
          text: `<p>Evet. Sadece sizin ve hatta dilerseniz sizin yetki verdiğiniz kişi / kurumların erişimine a&ccedil;ık, sizin operasyonlarınıza &ouml;zel Online İ&ccedil; Denetim uygulamalarını birlikte oluşturabilir, raporlarını sizlerin kullanımınıza a&ccedil;abiliriz.</p>
<p>Bağlı şirketlerinizi gerek duyduğunuz İ&ccedil; Denetim uygulamalarına y&ouml;nlendirebilirsiniz. Değerlendirme sonu&ccedil;larını g&ouml;rebilir, kendi kullanımınız i&ccedil;in raporlayabilirsiniz.&nbsp;</p>
<p>T&uuml;rkiye&rsquo;ye yayılmış ve &uuml;r&uuml;nlerinizi satan distrib&uuml;t&ouml;rler i&ccedil;in stok, konsinye mal, saha operasyonları ve diğer benzeri Online İ&ccedil; Denetim uygulamaları i&ccedil;in birlikte &ccedil;alışabiliriz.</p>
<p>M&uuml;şteri se&ccedil;im s&uuml;recinizde size yardımcı olacak, aday kurumların &ouml;n analizinde kullanılacak &ouml;zel denetim uygulamaları hazırlayabiliriz. Aday kurumları bu analizlere y&ouml;nlendirerek &ndash; değerlendirerek karar mekanizmanızı g&uuml;&ccedil;lendirebilirsiniz.</p>
<p>Tedarik&ccedil;ilerinizin operasyonlarına y&ouml;nelik s&uuml;re&ccedil; denetim uygulamaları hazırlayabilir, gelişimlerini devamlı kontrol altında takip edebilirsiniz.&nbsp;</p>
`
        },
        {
          title: 'Online İç Denetim uygulama üyeliğimi iptal etmek istersem ne yapmalıyım?',
          text:
            '<p>Kullanıcı profili altında “Üyeliğimi İptal Et” butonu ile üyeliğinizi iptal edebilir, bilgilerinizi erişime kapatabilirsiniz.</p>'
        }
      ]
    }
  }
}
</script>
